const childrenIds = state => state.childrenIds
const nurserySearchId = state => state.nursery_search_id

export default {
  childrenIds,
  nurserySearchId
}
